import { useState } from 'react';
import './AgentAutoReloadModal.css';

export default function AgentAutoReloadModal({
  isOpen,
  onClose,
  onEnableAutoReload,
  onCreateBlankProject,
  title = 'Enable auto-reload for agent projects',
  description = 'Your first project is free. To continue with full agentic project creation, your account needs auto-reload enabled. Configure your settings below, then continue with the agent.',
  secondaryLabel = 'Create blank project instead',
}) {
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [thresholdCents, setThresholdCents] = useState(500);
  const [amountCents, setAmountCents] = useState(2500);

  if (!isOpen) return null;

  const handleEnable = async () => {
    setError(null);
    setSaving(true);
    try {
      await onEnableAutoReload({
        thresholdCents,
        amountCents,
      });
    } catch (err) {
      setError('Failed to enable auto-reload');
      setSaving(false);
      return;
    }
    setSaving(false);
  };

  const handleBlank = async () => {
    setError(null);
    setSaving(true);
    try {
      await onCreateBlankProject();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="agent-auto-reload-backdrop" role="presentation" onClick={onClose}>
      <div
        className="agent-auto-reload-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="agent-auto-reload-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="agent-auto-reload-header">
          <h2 id="agent-auto-reload-title">{title}</h2>
          <p>{description}</p>
        </header>

        <div className="agent-auto-reload-config">
          <div className="agent-auto-reload-row">
            <span className="agent-auto-reload-label">Reload when below</span>
            <select
              value={thresholdCents}
              onChange={(e) => setThresholdCents(parseInt(e.target.value, 10))}
              disabled={saving}
              className="agent-auto-reload-select"
            >
              <option value={200}>$2</option>
              <option value={500}>$5</option>
              <option value={1000}>$10</option>
              <option value={2000}>$20</option>
              <option value={5000}>$50</option>
            </select>
          </div>
          <div className="agent-auto-reload-row">
            <span className="agent-auto-reload-label">Reload amount</span>
            <select
              value={amountCents}
              onChange={(e) => setAmountCents(parseInt(e.target.value, 10))}
              disabled={saving}
              className="agent-auto-reload-select"
            >
              <option value={1000}>$10</option>
              <option value={2500}>$25</option>
              <option value={5000}>$50</option>
              <option value={10000}>$100</option>
            </select>
          </div>
        </div>

        <div className="agent-auto-reload-actions">
          <button
            type="button"
            className="agent-auto-reload-primary"
            onClick={handleEnable}
            disabled={saving}
          >
            Enable auto-reload and continue
          </button>
          {onCreateBlankProject ? (
            <button
              type="button"
              className="agent-auto-reload-secondary"
              onClick={handleBlank}
              disabled={saving}
            >
              {secondaryLabel}
            </button>
          ) : null}
        </div>

        {error ? <p className="agent-auto-reload-error">{error}</p> : null}
      </div>
    </div>
  );
}
